import { useCallback, useState } from 'react';

type LookupRequestStatus = 'initial' | 'loading' | 'notFound' | 'requestError';

export const useLookupRequestState = () => {
  const [status, setStatus] = useState<LookupRequestStatus>('initial');

  const beginRequest = useCallback(() => {
    setStatus('loading');
  }, []);

  const markNotFound = useCallback(() => {
    setStatus('notFound');
  }, []);

  const markRequestError = useCallback(() => {
    setStatus('requestError');
  }, []);

  const endRequest = useCallback(() => {
    setStatus((currentStatus) =>
      currentStatus === 'loading' ? 'initial' : currentStatus
    );
  }, []);

  return {
    isLoading: status === 'loading',
    notFound: status === 'notFound',
    requestError: status === 'requestError',
    beginRequest,
    markNotFound,
    markRequestError,
    endRequest
  };
};
